"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SeriesPlot;

var _react = _interopRequireWildcard(require("react"));

var _reactVis = require("react-vis");

var _d3Format = require("d3-format");

var _utils = require("../../utils");

var _Constants = require("../../Constants");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var W = _Constants.PLOT_W;
var FlexibleXYPlot = (0, _reactVis.makeWidthFlexible)(_reactVis.XYPlot);

function SeriesPlot(options) {
  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      hint = _useState2[0],
      setHint = _useState2[1];

  var ReactSeries = options.type;
  if (!ReactSeries) return null;
  var limit = 10;
  var data = options.type !== _reactVis.MarkSeries && !options.noLimit && options.data && options.data.length > limit ? options.data.slice(0, limit) : options.data;
  var plotStyle = options.plotStyle,
      title = options.title,
      noXAxis = options.noXAxis,
      noYAxis = options.noYAxis,
      onValueClick = options.onValueClick,
      onDragSelected = options.onDragSelected;
  if (!data || !data.length) return null;
  return _react["default"].createElement("div", {
    className: "unselectable",
    style: {
      position: 'relative'
    }
  }, options.type !== _reactVis.MarkSeries && !options.noLimit && options.data && options.data.length > limit && _react["default"].createElement("h4", null, "Plotting first ", limit, " values:"), noYAxis && title && _react["default"].createElement("h4", null, title), _react["default"].createElement(FlexibleXYPlot, {
    xType: "ordinal",
    margin: {
      bottom: plotStyle && plotStyle.marginBottom || 40
    },
    animation: {
      duration: 1
    },
    height: plotStyle && plotStyle.height || W,
    width: plotStyle && plotStyle.width || W,
    onMouseLeave: function onMouseLeave() {
      setHint(false);
    }
  }, !noXAxis && _react["default"].createElement(_reactVis.XAxis, {
    tickSize: 0,
    tickFormat: function tickFormat(v) {
      return (0, _utils.shortenName)(v, 10);
    },
    tickValues: data.length > limit ? data.filter(function (item, idx) {
      if (idx % Math.floor(data.length / limit) === 0) {
        return item.x;
      }
    }).map(function (item) {
      return item.x;
    }) : data.map(function (item) {
      return item.x;
    }),
    position: "right",
    tickLabelAngle: -65,
    style: {
      line: {
        strokeWidth: 0
      },
      text: {
        fill: options.dark ? '#fff' : '#000'
      }
    }
  }), !noYAxis && _react["default"].createElement(_reactVis.YAxis, {
    tickSize: 0,
    tickLabelAngle: -45,
    tickFormat: function tickFormat(v) {
      return (0, _d3Format.format)(".2s")(v);
    },
    style: {
      line: {
        strokeWidth: 0
      },
      title: {
        fill: options.dark ? '#fff' : '#000'
      },
      text: {
        fill: options.dark ? '#fff' : '#000'
      }
    },
    position: "start",
    title: title
  }), _react["default"].createElement(ReactSeries, {
    onValueClick: onValueClick,
    onNearestX: function onNearestX(datapoint) {
      setHint({
        x: datapoint.x,
        y: datapoint.y
      });
    },
    data: data
  }), hint && _react["default"].createElement(_reactVis.Hint, {
    value: hint
  })));
}